import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-no-connext-account-id-error',
  templateUrl: './no-connext-account-id-error.component.html',
  styleUrls: ['./no-connext-account-id-error.component.scss'],
  imports: [MatIconModule, MatTooltipModule],
})
export class NoConnextAccountIdErrorComponent {
  text: string =
    'Für diese Person fehlt eine gültige Zahlungsmethode. Bitte hinterlegen Sie eine gültige IBAN für ein Sepa-Lastschriftverfahren bei dieser Person, da nicht über das Verwahrgeldkonto abgerechnet wird.';
  constructor() {}
}
